import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import Ls from "@/services/ls";

let table = Ls.get('table')
let info = Ls.get('table.info')

const initialState = {
    table: table ,
    info: info ? JSON.parse(info) : {},
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}